import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form, Modal, ModalFooter, Table } from "react-bootstrap";
import CardLessDataTableWithOutSearch from '../datatables/CardLessDataTableWithOutSearch';
import "./_singleRequest.scss"
import gql from "graphql-tag";
import moment, { invalid } from "moment";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import { withApollo } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";


const ADD_SINGLE_REQUEST_DETAILS = gql`
  mutation($params: AddPermissionDetails) {
    createIndividualPermissions(params: $params)
  }`

class SingleRequestModal extends Component {
    constructor() {
        super();
        this.state = {
            roll_mob: "",
            roll_mob_error: "",
            fromDate: "",
            fromDateError: "",
            toDate: "",
            toDateError: "",
            reqMessage: "",
            studentDetails: [],
            submitted: false,
            loader: 0,
            submitError: "",
            dataClear: 1,
            dataError: ""
            //    date: new Date().toISOString().slice(0, 10)
        }
    }

    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({
                roll_mob: "",
                roll_mob_error: "",
                fromDate: "",
                fromDateError: "",
                toDate: "",
                toDateError: "",
                reqMessage: "",
                studentDetails: [],
                submitted: false,
                loader: 0,
                dataClear: 1,
                dataError: ""
            })
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    }
    handleInputChange = (e) => {
        let name = e.target.name
        let value = e.target.value
        if (name == "roll_mob") {
            this.setState({
                roll_mob: value,
                roll_mob_error: "",
                studentDetails: [],
                fromDate: "",
                toDate: "",
                reqMessage: "",
                dataError: "",
                loader: 0

            })
        }
        if (name == "fromDate") {
            this.setState({
                fromDate: value,
                fromDateError: ""
            })
        }
        if (name == "toDate") {
            this.setState({
                toDate: value,
                toDateError: ""
            })
        }
        if (name == "reqMessage") {
            this.setState({
                reqMessage: value,
            })
        }

    }
    handleSubmit = () => {

        if (this.state.roll_mob == "") {
            this.setState({ roll_mob_error: "Please Enter valid Roll/Mobile", })
            return ""
        }

        this.setState({ loader: 1 });

        this.getStudentDetails()
    }

    getStudentDetails = async () => {
        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int){
                getNewEducationalStudents(institute_id: $institute_id) {
                    roll_no
                    student_name
                    class_id
                    class_name
                    exam_id
                    exam_name
                    branch_id
                    branch_name
                    section_id
                    section_name
                    parent_name
                    parent_mobile
                    parent_password
                    student_id
                    student_mobile
                  }
            }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getNewEducationalStudents.length > 0) {
            let filter_data = result.data.getNewEducationalStudents.filter((item) => item.roll_no == this.state.roll_mob || item.student_mobile == this.state.roll_mob)

            if (filter_data.length > 0) {
                this.setState({
                    studentDetails: filter_data,
                    loader: 0
                })
            } else {
                this.setState({ dataError: "No Data Found", loader: 0, studentDetails: [] })

            }
        }
    }

    handleSubmit2 = () => {
        if (this.state.fromDate == "") {
            this.setState({ fromDateError: "Please Select From Date" })
            return ""
        }
        if (this.state.toDate == "") {
            this.setState({ toDateError: "Please Select To Date" })
            return ""
        }

        const params = {
            student_mobile: this.state.studentDetails[0].student_mobile,
            from_datetime: moment(this.state.fromDate, 'YYYY-MM-DD HH:mm:ss').unix().toString(),
            to_datetime: moment(this.state.toDate, 'YYYY-MM-DD HH:mm:ss').unix().toString(),
            request_message: this.state.reqMessage,
            approved_by:parseInt(Cookies.get("id"))
        }
        this.setState({ loader: 2 })
        
        console.log("prrrr", params);
        this.createIndividualPermissions(
            params
        ).catch(error => {
            console.log("catch if error");
            console.log("params", params);
            console.log(error);


            this.setState({
                submitError: error.graphQLErrors.map(x => x.message),
                loader: 0
            });
            console.error("ERR =>", error.graphQLErrors.map(x => x.message));
        });
        
    }

    createIndividualPermissions = async (
        params) => {
        await this.props.createIndividualPermissions({
            variables: {
                params,
            },
            update: (store, { data }) => {
                console.log("data.finishTest", data);
                if(data.createIndividualPermissions){
                    console.log("mutation true");
                    this.setState({
                        submitted: true,
                        loader: 0,
                    })
                    setTimeout(() => {
                        this.props.onHide();
                        window.location.reload(false);
                    }, 1500);
                }
            }

        });
    };

    
    render() {
        console.log("lakshmi", this.state);
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="modal-title">Individual Request</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <Container fluid>
                        <Row>
                            <Col sm={12}>
                                <Form>
                                    <Form.Row>
                                        <Form.Group as={Col} lg={4} md={12} sm={12} controlId="SelectBranchName">
                                            <Form.Label className="">Rollno/Mobile</Form.Label>
                                            <Form.Control as="input" name="roll_mob" placeholder="Enter Your RollNo/Mobile" onChange={this.handleInputChange} >
                                            </Form.Control>
                                            <Form.Text className="form-text text-danger">
                                                {this.state.roll_mob_error}
                                            </Form.Text>

                                        </Form.Group>

                                        <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectBranch">
                                            <Button className="btn btn-dark text-uppercase submit_btn" onClick={this.handleSubmit}>Get Students</Button>
                                        </Form.Group>
                                    </Form.Row>
                                </Form>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                {
                                    this.state.loader == 1 ? (
                                        <span className="spinner-border spinner-border-sm text-center spinner-alignment"></span>
                                    ) : ""
                                }

                            </Col>
                        </Row>
                        {
                            this.state.studentDetails.length > 0 ?
                                <>
                                    <Row className="mt-3">
                                        <Col lg={12} md={12} sm={12} >
                                            <Table className="table  table-bordered">
                                                <thead>
                                                    <tr className="table-active">
                                                        <th>Student Name</th>
                                                        <th>Mobile No</th>
                                                        <th>Roll Number</th>
                                                        <th> Parent Name</th>
                                                        <th> Parent Mobile</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>{this.state.studentDetails[0].student_name}</td>
                                                        <td>{this.state.studentDetails[0].student_mobile}</td>
                                                        <td>{this.state.studentDetails[0].roll_no}</td>
                                                        <td>{this.state.studentDetails[0].parent_name}</td>
                                                        <td>{this.state.studentDetails[0].parent_mobile}</td>

                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <Col lg={4} sm={12}>
                                            <div>
                                                <h6>From Date:</h6>
                                                <input type="datetime-local" value={this.state.fromDate} name="fromDate" onChange={this.handleInputChange} style={{ width: "150px", height: "30px" }} />
                                            </div>
                                            <Form.Text className="form-text text-danger">
                                            {this.state.fromDateError}
                                            </Form.Text>
                                        </Col>
                                        <Col lg={4} sm={12} >
                                            <div>
                                                <h6>To Date:</h6>
                                                <input type="datetime-local" value={this.state.toDate} name="toDate" onChange={this.handleInputChange} style={{ width: "150px", height: "30px" }} />
                                            </div>
                                            <Form.Text className="form-text text-danger">
                                            {this.state.toDateError}
                                            </Form.Text>
                                        </Col>
                                        <Col lg={4} sm={12}>
                                            <h6>Request Message</h6>
                                            <textarea name="reqMessage" onChange={this.handleInputChange} style={{ width: "200px", height: "50px" }}></textarea>
                                        </Col>

                                    </Row>

                                    <Row>
                                        <Col sm={12} className="">
                                            <Button className=" btn btn-dark submit_btn2" onClick={this.handleSubmit2}>
                                                {
                                                    this.state.loader == 2 ? (
                                                        <span className="spinner-border spinner-border-sm"></span>
                                                    ) : ""
                                                }
                                                Send Request</Button>
                                            <div>
                                                {
                                                    this.state.submitted == true && this.state.loader == 0 ? (
                                                        <p className="text-success mt-1" >Submitted Successfully</p>
                                                    ) : ""
                                                }
                                                {
                                                    this.state.submitError != "" ? (
                                                        <span className="text-danger mt-1">{this.state.submitError}</span>
                                                    ) : ("")
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                                : (
                                    <Row>
                                        <Col sm={12} className="text-center">
                                            <span className="text-dark text-center">{this.state.dataError}</span>
                                        </Col>
                                    </Row>)
                        }
                    </Container>
                </Modal.Body>
            </Modal>
        )
    }

}
export default withRouter(withApollo(
    compose(
        graphql(ADD_SINGLE_REQUEST_DETAILS, {
            name: "createIndividualPermissions"
        })
    )(SingleRequestModal))
);
